// Google Analytics 4
function gtag() {
  window.dataLayer.push([...arguments]);
}

export const initGA = () => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    gtag("js", new Date());
    gtag("config", "G-YN637S0Y62");
  }
};

// Track page views
export const trackPageView = (path) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", "G-YN637S0Y62", {
      page_path: path,
    });
  }
};

// Track events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
